import { CALENDLY_LINK } from '../constants';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <nav className="navbar">
            <div className="nav-container">
                <Link to="/" className="logo" onClick={closeMenu}>Veloce Software</Link>

                <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle navigation">
                    <span className={`hamburger ${isOpen ? 'open' : ''}`}></span>
                </button>

                <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
                    <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                    <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
                    <li>
                        <button onClick={() => { window.open(CALENDLY_LINK, '_blank'); closeMenu(); }} className="nav-cta-button">
                            Gratis Advies
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
}
